import React, { FC, useEffect, useRef } from 'react';

interface RawHTMLProps {
  children?: string;
}

const RawHTML: FC<RawHTMLProps> = props => {
  const { children: html = '' } = props;
  const templateRef = useRef<HTMLTemplateElement | null>(null);
  const nodesRef = useRef<ChildNode[] | null>(null);

  useEffect(() => {
    const template = templateRef.current;

    if (!template) return;

    // remove previously inserted nodes
    nodesRef.current?.forEach(node => node.remove());

    // update current html
    template.innerHTML = html;
    nodesRef.current = [...template.content.childNodes];

    // insert new nodes
    template.after(...nodesRef.current);

    return () => {
      nodesRef.current?.forEach(node => node.remove());
    };
  }, [html]);

  return <template ref={templateRef} />;
};

export default RawHTML;
